import React from 'react';
import { QuoteIcon, StarIcon } from 'lucide-react';
import { Reveal } from './ui/Reveal';
import { testimonials } from '../data/content';
export function TestimonialsSection() {
  return <section aria-labelledby="testimonios" className="bg-white" data-id="element-195" data-mp="1n0aczfdwoovk">
      <div className="mx-auto max-w-page px-3 py-5 sm:px-6 sm:py-7" data-id="element-196" data-mp="1mxxyxdb9qyns">
        <Reveal className="text-center" data-id="element-197" data-mp="1r0b4a0m3suk1">
          <p className="text-[0.62rem] font-black uppercase tracking-[0.24em] text-azure sm:text-xs" data-id="element-198" data-mp="1qz9k96n40xq6">
            Lo que dicen quienes ya empezaron
          </p>
          <h2 id="testimonios" className="mt-0.5 font-display text-lg uppercase leading-tight text-navy sm:text-2xl lg:text-3xl" data-id="element-199" data-mp="1i2iokvcgzkw4">
            De cero a entender un proyecto solar
          </h2>
        </Reveal>

        <ul className="mt-3 grid gap-2 md:grid-cols-2 lg:grid-cols-3" data-id="element-200" data-mp="2yf7fns30jcle">
          {testimonials.map((item, i) => <Reveal key={item.name} as="li" delay={i * 0.03} className="flex h-full flex-col rounded-lg border border-navy/10 bg-mist p-3" data-id="element-201" data-mp="32haveswpt3ch" data-mpi={i}>
              <div className="flex items-center justify-between" data-id="element-202" data-mp="2q39gsa5bztby">
                <div className="flex gap-0.5" aria-label="5 de 5 estrellas" data-id="element-203" data-mp="34re11ik18cwu">
                  {Array.from({
                length: 5
              }).map((_, s) => <StarIcon key={s} size={13} className="fill-solar text-solar" data-id="element-204" data-mp="2ztc9e98jj59r" data-mpi={s} />)}
                </div>
                <QuoteIcon size={15} className="text-azure/40" aria-hidden="true" data-id="element-205" data-mp="274x44ef7o1bm" />
              </div>
              <p className="mt-1.5 font-body text-[0.76rem] leading-snug text-navy sm:text-[0.8rem]" data-id="element-206" data-mp="2h1jq56j9wyf8">
                “{item.text}”
              </p>
              <div className="mt-auto pt-2" data-id="element-207" data-mp="1crsp3vra2mz">
                <p className="font-condensed text-base uppercase tracking-wide text-azure" data-id="element-208" data-mp="3shrkwlsgr5gc">
                  {item.name}
                </p>
                <p className="text-[0.68rem] text-steel sm:text-[0.72rem]" data-id="element-209" data-mp="3eiss8c4gqgn">
                  {item.role} · {item.place}
                </p>
              </div>
            </Reveal>)}
        </ul>
      </div>
    </section>;
}